var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "marquee",
    staticClass: "scroll-text-marquee"
  }, [_c('SanityBlockContent', {
    staticClass: "scroll-text-marquee__text pointer-events-auto flex items-center",
    attrs: {
      "blocks": _vm.marqueeText
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };